import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useScope } from '@/contexts/ScopeContext';

/**
 * Nav convergence (Company model, post-2c): the portfolio no longer has its own
 * page. `/app/portfolio` and everything that linked to it (onboarding, target
 * back-nav, the diligence "Open deals" link) now resolve to the single
 * scope-aware home at `/app`, first clearing scope to Portfolio so the landing
 * is always the portfolio command centre regardless of the prior selection.
 */
export function PortfolioRedirect() {
  const { setActiveCompany } = useScope();
  useEffect(() => {
    setActiveCompany(null);
  }, [setActiveCompany]);
  return <Navigate to="/app" replace />;
}
